/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Page, Content, Copy, BodyCopy } from '@insticator/insticator-ui'; // iui-material
import EmbedControls from 'material/embeds/embedcontrols/embedcontrols_container';
import FlowControls from 'material/embeds/flowcontrols/flowcontrols_container'
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/placement/placement_styles';



/* ========== ~~~~~~~~~~ EMBED PLACEMENT ~~~~~~~~~~ ========== */
class PlacementPage extends Component {
    constructor(props) {
        super(props);
        this.placementClicked = false;
        this.timeoutId = null
    }
    componentWillUnmount() {
        clearTimeout(this.timeoutId)
    }
    isStep = () => !!this.props.currentStepPage ? 'step' : 'standard';
    selectVisual = e => {
        if(this.placementClicked ) return;
        this.placementClicked = this.props.isNewEmbedFlow;
        this.props.setEmbedPlacement(e.currentTarget.id);
        // Move to the next page with delay // Do not move if editing the existing embed.
        // During this delay a selected placement will be highlighted for a better ux.
        this.timeoutId = this.props.isNewEmbedFlow ? setTimeout(() => {
            this.props.moveToPage(this.props.stepQueue[this.props.currentStepIndex + 1].name);
            clearTimeout(this.timeoutId)
        }, 250) : null;
    };
    setSelectedClass = () => this.props.location === null ? 'none' : this.props.location;

    
    /* /////////////// RENDER \\\\\\\\\\\\\\\ */
    render() {
        return(
            <Page name={`placement`} klass={`${this.props.classes.placement} ${this.isStep()}`}>
                <Content>
                    <EmbedControls handleSaveEmbed={this.props.handleSaveEmbed} />
                    <Copy>
                        <BodyCopy>
                            <p>Please pick where you think you would like to place your Embed on your website</p>
                        </BodyCopy>
                    </Copy>
                    <div className={`placement-select selected-${this.setSelectedClass()}`}>
                        <div id={`rail`} className={`placement-location rail`} onClick={this.selectVisual}>
                            <div className={`name`}>Right or Left Rail</div>
                            <div className={`visual`} />
                        </div>
                        <div id={`in-content`} className={`placement-location in-content`} onClick={this.selectVisual}>
                            <div className={`name`}>In-Content</div>
                            <div className={`visual`} />
                        </div>
                    </div>
                    {!this.props.isNewEmbedFlow ? <FlowControls handleSaveEmbed={this.props.handleSaveEmbed} /> : null}
                </Content>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(PlacementPage);
